var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.998,
    height: 23.998,
    viewBox: "0 0 23.998 23.998",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "search-interface-symbol",
    transform: "translate(-0.006)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x34__4_",
    transform: "translate(0.006)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1178",
    "data-name": "Group 1178",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12240",
    "data-name": "Path 12240",
    d: "M23.777,22.693l-6.2-6.1A9.8,9.8,0,0,0,20.2,9.936,10.018,10.018,0,0,0,10.1,0,10.017,10.017,0,0,0,.006,9.936a10.017,10.017,0,0,0,10.1,9.936,10.154,10.154,0,0,0,6.355-2.219l6.22,6.121a.785.785,0,0,0,1.1,0A.756.756,0,0,0,23.777,22.693ZM10.1,18.343A8.476,8.476,0,0,1,1.559,9.936,8.476,8.476,0,0,1,10.1,1.529a8.476,8.476,0,0,1,8.543,8.407A8.476,8.476,0,0,1,10.1,18.343Z",
    transform: "translate(-0.006)",
    fill: "#868686"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/searchIcon.21ddaea2fa15846d55b70847912142ba.svg";
export { ForwardRef as ReactComponent };